"use client";

import GigsConsolePanel from "@/components/gigs/console/GigsConsolePanel";

export function ActivitiesPanel() {
    return (
        <div className="space-y-6">
            <GigsConsolePanel isEmbedded={true} />
        </div>
    );
}

